import Calculations from '@components/shared/navbar/help/Calculations';
import { CALCULATIONS } from '../domain/calculations';
import { HelpTabs } from '@components/shared/navbar/help/HelpTabs';
import BenchmarksCPG from '@components/shared/navbar/help/Benchmarks/BenchmarksCPG';
import Glossary from '@components/shared/navbar/help/Glossary';
import { GLOSSARY } from '../domain/glossary';

export const HelpContent = () => {
  return (
    <HelpTabs
      tabs={[
        { label: 'Glossary', component: <Glossary glossary={GLOSSARY} /> },
        {
          label: 'Calculations',
          component: <Calculations calculations={CALCULATIONS} />,
        },
        {
          label: 'Benchmarks',
          component: <BenchmarksCPG />,
        },
      ]}
    />
  );
};
